import {
    PRESET_LIGHT_TYPES,
    buildPresetTypeImages,
    getPresetTypeImagePath,
    normalizeLight,
    normalizeLightsCollection,
    isExistingLoadedLight,
    serializeLightsForSave,
    getLightTypeDisplay,
    getLightTableImage,
    getLightTestResultDisplay,
    isLightInvalid,
} from "../include/ElightingLights";

export default {
    data() {
        return {
            presetLightTypes: PRESET_LIGHT_TYPES,
        };
    },

    computed: {
        presetTypeImages() {
            return buildPresetTypeImages();
        },
    },

    methods: {
        getPresetTypeImagePath,
        normalizeLight,
        normalizeLightsCollection,
        isExistingLoadedLight,
        serializeLightsForSave,
        getLightTypeDisplay,
        getLightTestResultDisplay,
        isLightInvalid,
        getLightTableImage(light) {
            return getLightTableImage(light, this.presetTypeImages);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/UsesElightingLights.js